
export class CTA{
  
    createdAt: Date;
    image: string;
    quote: string;
    subtitle: string;
    url: string;
    
}